module.exports = __webpack_public_path__ + "assets/images/glasses-04.60955c6689bc96e1056f837ae21bfe45.svg";